import {
  queryOptions,
  useQueryClient,
  useMutation as useReactQueryMutation,
} from '@tanstack/react-query';

import type { AccessToken } from '@/lib/tokenStorage';
import { useAccessToken } from '@/services/auth';

import { chuteSchedulerApi } from './api';
import { BulkRevisionUpdateInput } from './types';

export function donorSchedulesByIdsQueryOptions(
  token: AccessToken,
  ids: string[],
) {
  return queryOptions({
    queryKey: ['donorSchedulesByIds', ids],
    queryFn: () => chuteSchedulerApi.fetchDonorSchedulesByIds(token, ids),
    enabled: !!token && ids.length > 0,
  });
}

export const useBulkRevisionUpdate = () => {
  const queryClient = useQueryClient();
  const token = useAccessToken();

  return useReactQueryMutation({
    mutationFn: (input: BulkRevisionUpdateInput) =>
      chuteSchedulerApi.bulkRevisionUpdate(token, input),
    onSuccess: () => {
      queryClient.invalidateQueries(donorSchedulesByIdsQueryOptions(token, []));
    },
  });
};
